import { render } from "./Missing.vue?vue&type=template&id=073f0ff8"
import script from "./Missing.vue?vue&type=script&lang=js"
export * from "./Missing.vue?vue&type=script&lang=js"
script.render = render

export default script